import { useCallback, useState } from 'react';

/**
 * Hook to handle the step navigation for the onboarding process
 */
export function useStepNavigation(stepsCount: number, initialStep = 0) {
  const [currentStep, setCurrentStep] = useState(initialStep);

  const handleBackStep = useCallback(() => {
    setCurrentStep((prev) => Math.max(prev - 1, 0));
  }, []);

  const handleNext = useCallback(() => {
    setCurrentStep((prev) => Math.min(prev + 1, stepsCount - 1));
  }, [stepsCount]);

  return { currentStep, setCurrentStep, handleBackStep, handleNext };
}